// Backend API address (2026-09-02): the public HTTPS API, unconditionally.
// Both the web build and the shipped APK call the live backend — a
// distributed app must never call a loopback address (the user's phone has
// no backend there), and dev sessions use the live backend too. To test
// against a different backend, edit this constant: nothing here reads
// environment variables, so this file is exactly what ships.
export const THOTH_BACKEND_API = "https://api.divinearts.co.uk";
